import type { ArticleSummary } from '@rabbit/shared';
import { ArrowDown, ArrowRight, Route } from 'lucide-react';
import type { Copy } from '../i18n';

export function SharedJourney({ articles, pathLength, copy, onContinue }: { articles: ArticleSummary[]; pathLength: number; copy: Copy; onContinue: () => void }) {
  const path = articles.slice(0, pathLength);
  const current = articles[pathLength] ?? articles.at(-1);
  return (
    <div className="shared-overlay" role="dialog" aria-modal="true" aria-labelledby="shared-title" data-testid="shared-journey">
      <div className="shared-icon"><Route /></div>
      <span className="eyebrow">Rabbit</span>
      <h2 id="shared-title">{copy.sharedTitle}</h2>
      <div className="shared-path">
        {path.map((article, index) => <div key={`${article.id}-${index}`}><strong>{article.displayTitle}</strong>{index < path.length - 1 && <ArrowDown size={14}/>}</div>)}
      </div>
      {current && <div className="now-viewing"><span>{copy.nowViewing}</span><strong>{current.displayTitle}</strong></div>}
      <button className="primary-button wide" type="button" onClick={onContinue}>{copy.continueHere}<ArrowRight size={18}/></button>
    </div>
  );
}
